module.exports = __webpack_public_path__ + "static/media/checkmark.29ceef6c.svg";